import React, { useEffect, useState } from "react";
import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";
import {
    DELETE_RP_ALARM,
    DELETE_RP_SUMMARY_ALARM,
    GET_RP_ALARM,
    GET_RP_SUMMARY_ALARM,
    SAVE_LIST_RP_ALARM,
    SAVE_LIST_RP_SUMMARY_ALARM,
    SAVE_RP_ALARM,
    SAVE_RP_SUMMARY_ALARM
} from "../../../../helpers/url_api_constant";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Badge,
    Table,
    CardTitle,
} from "reactstrap";

import PropTypes from "prop-types";
import moment from "moment";
import PieChart from "../SectionAlarm/PieChart";
import { useDispatch } from "react-redux";
import { post, postUpload } from "../../../../helpers/api_helper";

function SectionAlarm(props) {
    // console.log(props);
    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }

    const dispatch = useDispatch();
    // const [searchDate, setSearchDate] = useState(moment(new Date().setDate(new Date().getDate() - 1)).format(
    //     "YYYY-MM-DD"));
    const searchDate = { SUMMARYREPORT_PID: props.summaryReportPid, SELECT_DATE: props.date };

    const [listAlarmMedium, setListAlarmMedium] = useState([]);
    const [listAlarmUrgent, setListAlarmUrgent] = useState([]);

    const [totalSummary, setTotalSummary] = useState({ ALARM_MEDIUM: 0, ALARM_URGENT: 0, ALARM_NORMAL: 0, ALARM_EVENT: 0 });

    const [totalMedium, setTotalMedium] = useState(null);
    const [totalUrgent, setTotalUrgent] = useState(null);

    useEffect(function () {
        fetchData();
    }, [props.summaryReportPid]);

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.TOTAL > b.TOTAL) {
            return -1;
        }
        if (a.TOTAL < b.TOTAL) {
            return 1;
        }
        return 0;
    }

    const fetchData = async () => {
        let sumMedium = 0;
        let sumUrgent = 0;

        dispatch(loadingAction.showLoading());
        // console.log(searchDate);
        try {
            let res = await post(GET_RP_ALARM, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" });
            let summary = await post(GET_RP_SUMMARY_ALARM, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" });
            // console.log(res);
            // console.log(summary);
            if (res.data.rpAlarmList != null) {

                let ListTotalAlarmMedium = res.data.rpAlarmList.sort(compare).filter((obj) => obj.ALARM_TYPE == "MEDIUM");
                let ListTotalAlarmUrgent = res.data.rpAlarmList.sort(compare).filter((obj) => obj.ALARM_TYPE != "MEDIUM");

                setListAlarmMedium(
                    ListTotalAlarmMedium
                );

                setListAlarmUrgent(
                    ListTotalAlarmUrgent
                );

                if (summary.data.rpAlarmSummaryList.length == 1) {
                    setTotalSummary(summary.data.rpAlarmSummaryList[0]);
                };

                // for (let i = 0; i < ListTotalAlarmMedium.length; i++) {
                //     sumMedium += ListTotalAlarmMedium[i].TOTAL;
                // }

                // for (let i = 0; i < ListTotalAlarmUrgent.length; i++) {
                //     sumUrgent += ListTotalAlarmUrgent[i].TOTAL;
                // }
                // setTotalUrgent(
                //     sumMedium
                // );
                // setTotalMedium(
                //     sumUrgent
                // );

            } else {
                setListAlarmMedium([]);
                setListAlarmUrgent([]);
                setTotalSummary({});

                // setTotalMedium(null);
                // setTotalUrgent(null);

            }

        } catch (err) {
            dispatch(messageAction.showMessage(err.message));
        }
        dispatch(loadingAction.hideLoading());
    };



    function RenderListAlarmMedium(prop) {
        // console.log(prop);
        return (
            <tr>
                <td className="text-center">{prop.indexlist}</td>
                <td className="text-center">{prop.data.TAG_NAME}</td>
                <td className="text-center">{prop.data.TAG_DESC}</td>
                <td className="text-center">{prop.data.TOTAL}</td>
                <td className="text-center">{prop.data.USER_GROUP}</td>
                {/* <td className="text-center">{prop.data.REGION_CODE}</td> */}
                <td className="text-center">{prop.data.STATE}</td>
                <td className="text-center">{prop.data.RTU_CODE}</td>
                {/* <td className="text-center">{prop.data.DASHBOARD_DESC}</td> */}
                {/* <td className="text-center">
                    <div>
                        <Input
                            type="textarea"
                            className="form-control"
                            disabled
                            rows="2"
                            style={{ height: "100%", resize: "none" }}

                            // onChange={e =>
                            //     setListAlarmUrgent(prevData => {
                            //         return prevData.map(item => {
                            //             if (item.PID === row.PID) {
                            //                 return { ...item, DASHBOARD_DESC: e.target.value };
                            //             }
                            //             return { ...item };
                            //         });
                            //     })
                            // }
                            value={prop.data.DASHBOARD_DESC}
                        />
                    </div>
                </td> */}
                <td className="text-center">
                    <div style={{ position: "relative", }}>
                        <div style={{
                            wordWrap: "break-word",
                            width: "17vw",
                            paddingHorizontal: "3px",
                            // width:"100%",
                            height: "8vh",
                            // overflowY: prop.data.DASHBOARD_DESC.length >= 165 ? "scroll" : "hidden",
                            overflowY: "auto",
                            // fontSize:"1.5vh"
                        }}>{prop.data.DASHBOARD_DESC}
                        </div>
                    </div>
                </td>
            </tr>
        );
    }

    function RenderListAlarmUrgent(prop) {
        // console.log(prop);
        return (
            <tr>
                <td className="text-center">{prop.indexlist}</td>
                <td className="text-center">{prop.data.TAG_NAME}</td>
                <td className="text-center">{prop.data.TAG_DESC}</td>
                <td className="text-center">{prop.data.TOTAL}</td>
                <td className="text-center">{prop.data.USER_GROUP}</td>
                {/* <td className="text-center">{prop.data.REGION_CODE}</td> */}
                <td className="text-center">{prop.data.STATE}</td>
                <td className="text-center">{prop.data.RTU_CODE}</td>
                {/* <td className="text-center">{prop.data.DASHBOARD_DESC}</td> */}
                {/* <td className="text-center">
                    <div>
                        <Input
                            type="textarea"
                            className="form-control"
                            disabled
                            rows="2"
                            style={{ height: "100%",width:"100%" }}
                            // onChange={e =>
                            //     setListAlarmUrgent(prevData => {
                            //         return prevData.map(item => {
                            //             if (item.PID === row.PID) {
                            //                 return { ...item, DASHBOARD_DESC: e.target.value };
                            //             }
                            //             return { ...item };
                            //         });
                            //     })
                            // }
                            value={prop.data.DASHBOARD_DESC}
                        />
                    </div>
                </td> */}
                <td className="text-center">
                    <div style={{ position: "relative", }}>
                        <div style={{
                            wordWrap: "break-word",
                            width: "17vw",
                            paddingHorizontal: "3px",
                            // width:"100%",
                            height: "8vh",
                            // overflowY: prop.data.DASHBOARD_DESC.length >= 165 ? "scroll" : "hidden",
                            overflowY: "auto",
                            // fontSize:"1.5vh"
                        }}>{prop.data.DASHBOARD_DESC}
                        </div>
                    </div>
                </td>
            </tr>
        );
    }

    return (
        <Row>

            <Row className="mt-0">
                <Col sm="6">
                    <h5 className="mb-0 sm-0" style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}> Alarm Management </h5>
                </Col>
                <Col sm="6">
                    <h5
                        className="mb-0 sm-0 d-flex align-items-center justify-content-end"
                        style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
                    >
                        Gas Day : {moment(props.date).locale("en").format("DD MMM YYYY")}

                    </h5>
                </Col>
            </Row>

            <Row className="mt-2">
                <hr />
            </Row>

            <div className="d-flex dashboard-content-body">

                <div className="d-flex" style={{ flex: 1.6, paddingRight: 0 }}>
                    <div className="d-flex flex-column" style={{ flex: 1 }}>


                        <div className="d-flex" style={{ flex: 1 }}>
                            <div className="d-flex flex-column" style={{ flex: 1, position: 'relative' }}>
                                <Table className="table table-bordered mb-0" style={{ height: '100%' }}>
                                    <thead style={{ fontSize: "1.7vh", textAlign: "center" }}>
                                        <tr>
                                            {/* สีเดิม ff000073 */}
                                            <th colSpan={8} style={{ backgroundColor: "#ff00008c", color: "#FFFFFF", textAlign: "left", width: "100%", fontWeight: "bold", }}>Top Urgent Alarm</th>
                                        </tr>
                                        <tr>
                                            <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", width: "3%", fontWeight: "bold", whiteSpace: "nowrap" }}>No.</th>
                                            <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", width: "15%", fontWeight: "bold", whiteSpace: "nowrap" }}>Tag Name</th>
                                            <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", width: "20%", fontWeight: "bold", whiteSpace: "nowrap" }}>Description</th>
                                            <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", width: "8%", fontWeight: "bold", whiteSpace: "nowrap" }}>Count</th>
                                            <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", width: "8%", fontWeight: "bold", whiteSpace: "nowrap" }}>User</th>
                                            {/* <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", width: "8%", fontWeight: "bold", whiteSpace: "nowrap" }}>Region</th> */}
                                            <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", width: "8%", fontWeight: "bold", whiteSpace: "nowrap" }}>State</th>
                                            <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", width: "8%", fontWeight: "bold", whiteSpace: "nowrap" }}>RTU</th>
                                            <th style={{ backgroundColor: "#ff000047", color: "#ed6363f2", width: "30%", fontWeight: "bold", whiteSpace: "nowrap" }}>Cause</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.7vh", fontWeight: "bold", backgroundColor: "#ff000014" }}>
                                        {listAlarmUrgent.map((value, index) => (<RenderListAlarmUrgent key={index} data={value} indexlist={index + 1} />))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        <div className="d-flex" style={{ flex: 1 }}>
                            <div className="d-flex flex-column" style={{ flex: 1, position: 'relative', paddingTop: 3 }}>
                                <Table className="table table-bordered mb-0 mt-0" style={{ height: '100%' }}>
                                    <thead style={{ fontSize: "1.7vh", fontWeight: "bold", textAlign: "center" }}>
                                        <tr>
                                            <th colSpan={8} style={{ backgroundColor: "#ff5b1994", color: "#FFFFFF", textAlign: "left", width: "100%", fontWeight: "bold", }}>Top Medium Alarm</th>
                                        </tr>
                                        <tr>
                                            <th style={{ backgroundColor: "#ff5b1959", color: "rgba(215,172,108,1)", width: "3%", whiteSpace: "nowrap" }}>No.</th>
                                            <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", width: "15%", fontWeight: "bold", whiteSpace: "nowrap" }}>Tag Name</th>
                                            <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", width: "20%", fontWeight: "bold", whiteSpace: "nowrap" }}>Description</th>
                                            <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", width: "8%", fontWeight: "bold", whiteSpace: "nowrap" }}>Count</th>
                                            <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", width: "8%", fontWeight: "bold", whiteSpace: "nowrap" }}>User</th>
                                            {/* <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", width: "8%", fontWeight: "bold", whiteSpace: "nowrap" }}>Region</th> */}
                                            <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", width: "8%", fontWeight: "bold", whiteSpace: "nowrap" }}>State</th>
                                            <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", width: "8%", fontWeight: "bold", whiteSpace: "nowrap" }}>RTU</th>
                                            <th style={{ backgroundColor: "#ff5b1959", color: "#d7ac6c", width: "30%", fontWeight: "bold", whiteSpace: "nowrap" }}>Cause</th>
                                        </tr>

                                    </thead>
                                    <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.7vh", fontWeight: "bold", backgroundColor: "#f947001c" }}>
                                        {listAlarmMedium.map((value, index) => (<RenderListAlarmMedium key={index} data={value} indexlist={index + 1} />))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                    </div>
                </div>



                <div className="d-flex" style={{ flex: 0.7, paddingLeft: 3 }}>
                    <div className="d-flex flex-column" style={{ flex: 1 }}>

                        <div className="d-flex" style={{ flex: 1 }}>
                            <div className="d-flex flex-column" style={{ flex: 1, position: 'relative' }}>
                                <div id="pie-chart" className="e-chart">
                                    {/* <Alarm date = {searchModel.Date} /> */}
                                    <PieChart dataAlarmMedium={totalSummary.ALARM_MEDIUM} dataAlarmUrgent={totalSummary.ALARM_URGENT} dataAlarmNormal={totalSummary.ALARM_NORMAL} dataAlarmEvent={totalSummary.ALARM_EVENT} />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex" style={{ flex: 1 }}>
                            <div className="d-flex flex-column" style={{ flex: 1, position: 'relative' }}>
                                <Table className="table table-bordered mb-0 mt-3" style={{ height: "100%" }}>
                                    <thead style={{ fontSize: "2vh", textAlign: "center" }}>
                                        <tr>
                                            <th colSpan={8} style={{ backgroundColor: "#556ee64a", color: "#FFFFFF", textAlign: "left", width: "100%", fontWeight: "bold" }}>Realtime Alarm Info</th>
                                        </tr>
                                        <tr>
                                            <th style={{ backgroundColor: "#466597", color: "#FEF6AA", width: "20%", fontWeight: "bold" }}>Alarm</th>
                                            <th style={{ backgroundColor: "#466597", color: "#FEF6AA", width: "20%", fontWeight: "bold" }}>Total</th>
                                            <th style={{ backgroundColor: "#466597", color: "#FEF6AA", width: "20%", fontWeight: "bold" }}>Percent(%)</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "2vh", fontWeight: "bold" }}>
                                        <tr style={{ color: "#FF4545" }}>
                                            <td>Urgent</td>
                                            <td>{numberFormat(totalSummary.ALARM_URGENT, 0)}</td>
                                            <td>{numberFormat(((totalSummary.ALARM_URGENT * 100) / (totalSummary.ALARM_MEDIUM + totalSummary.ALARM_URGENT +
                                                totalSummary.ALARM_EVENT + totalSummary.ALARM_NORMAL)), 2)} %</td>
                                            {/* <td>{totalUrgent}</td>
                                                        <td>{((totalUrgent * 100) / (totalMedium + totalUrgent)).toFixed(2)} %</td> */}
                                        </tr>
                                        <tr style={{ color: "#DE7332" }}>
                                            <td>Medium</td>
                                            <td>{numberFormat(totalSummary.ALARM_MEDIUM, 0)}</td>
                                            <td>{numberFormat(((totalSummary.ALARM_MEDIUM * 100) / (totalSummary.ALARM_MEDIUM + totalSummary.ALARM_URGENT +
                                                totalSummary.ALARM_EVENT + totalSummary.ALARM_NORMAL)), 2)} %</td>
                                            {/* <td>{totalMedium}</td>
                                                        <td>{((totalMedium * 100) / (totalMedium + totalUrgent)).toFixed(2)} %</td> */}
                                        </tr>
                                        <tr style={{ color: "#DBFE6C" }}>
                                            <td>Normal</td>
                                            <td>{numberFormat(totalSummary.ALARM_NORMAL, 0)}</td>
                                            <td>{numberFormat(((totalSummary.ALARM_NORMAL * 100) / (totalSummary.ALARM_MEDIUM + totalSummary.ALARM_URGENT +
                                                totalSummary.ALARM_EVENT + totalSummary.ALARM_NORMAL)), 2)} %</td>

                                            {/* <td>{totalUrgent}</td>
                                                        <td>{((totalUrgent * 100) / (totalMedium + totalUrgent)).toFixed(2)} %</td> */}
                                        </tr>
                                        <tr style={{ color: "#5DE7FD" }}>
                                            <td>Event</td>
                                            <td>{numberFormat(totalSummary.ALARM_EVENT, 0)}</td>
                                            <td>{numberFormat(((totalSummary.ALARM_EVENT * 100) / (totalSummary.ALARM_MEDIUM + totalSummary.ALARM_URGENT +
                                                totalSummary.ALARM_EVENT + totalSummary.ALARM_NORMAL)), 2)} %</td>
                                            {/* <td>{totalUrgent}</td>
                                                        <td>{((totalUrgent * 100) / (totalMedium + totalUrgent)).toFixed(2)} %</td> */}
                                        </tr>
                                        <tr style={{ backgroundColor: "#466597" }}>
                                            {/* 556ee64a */}
                                            <td>Summary</td>
                                            <td>{numberFormat(totalSummary.ALARM_MEDIUM + totalSummary.ALARM_URGENT + totalSummary.ALARM_EVENT + totalSummary.ALARM_NORMAL, 0)}</td>
                                            <td>100 %</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>


                    </div>
                </div>



            </div>
        </Row>
    )
}

SectionAlarm.propTypes = {
    t: PropTypes.any,
    date: PropTypes.any,
    summaryReportPid: PropTypes.any,
}

export default SectionAlarm
